// extracted by mini-css-extract-plugin
export default {"fr-view":"GameCard_fr-view__UzBvW","container":"GameCard_container__oBnLU","logo":"GameCard_logo__25me6","title":"GameCard_title__-ufH3","action":"GameCard_action__dAOOo"};